import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  name: 'Agustín',
  age: 34,
  text: 'Viaje al Pasado está buenísimo. Arrancás con un caso y terminás diciendo "uno más". Con mi novia nos ponemos a resolverlos después de cenar y ya se volvió nuestro plan.'
}, {
  name: 'Martina',
  age: 29,
  text: 'Lo compré para tener algo distinto para hacer con amigos y terminó siendo un éxito. Nos juntamos, elegimos un caso y cada uno empieza a tirar teorías. Es súper entretenido.'
}, {
  name: 'Nicolás',
  age: 38,
  text: 'Pensé que iba a resolver un par y dejarlo para otro día, pero son bastante adictivos. Sopicidios y Murdoku fueron los que más me engancharon porque siempre querés pasar al siguiente.'
}, {
  name: 'Camila',
  age: 31,
  text: 'Me encantó que no sean todos iguales. Hay lógica, sopas de letras, escenas para investigar, acertijos… Con mi pareja vamos cambiando de libro según lo que tenemos ganas de hacer.'
}, {
  name: 'Sofía',
  age: 27,
  text: 'Lo llevé a una juntada pensando que íbamos a hacer uno o dos desafíos y estuvimos horas. Lo mejor es cuando todos creen tener la respuesta y empiezan a discutir quién es el culpable.'
}];
export const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <div className="relative max-w-4xl mx-auto px-12" data-id="element-156" data-mp="2bcnwp78ztmlw">
      <button onClick={prev} aria-label="Testimonio anterior" className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F97316] hover:text-white transition-colors z-10" data-id="element-157" data-mp="2bd5zynu2p13b">
        <ChevronLeft size={24} data-id="element-158" data-mp="9iwz2fztielg" />
      </button>

      <div className="overflow-hidden py-4" data-id="element-159" data-mp="4ly2zrwlfxkm">
        <AnimatePresence mode="wait" data-id="element-160" data-mp="4k3hocheu3g0">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border-t-4 border-[#F97316]" data-id="element-161" data-mp="1z1wjmi72x986">
            <div className="flex items-center gap-4 mb-4" data-id="element-162" data-mp="1u3ldoijwniv8">
              <div className="w-12 h-12 bg-[#5E1A8A] rounded-full flex items-center justify-center text-white font-bold text-xl shrink-0" data-id="element-163" data-mp="2hsmkk1d3alye">
                {testimonials[currentIndex].name.charAt(0)}
              </div>
              <div data-id="element-164" data-mp="28rg6s01trp8u">
                <h4 className="font-heading font-bold text-lg text-[#1E1E1E]" data-id="element-165" data-mp="28uaovkxd8xz3">
                  {testimonials[currentIndex].name},{' '}
                  {testimonials[currentIndex].age} años
                </h4>
                <div className="flex text-[#F97316]" data-id="element-166" data-mp="xffb016jn0jl">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-167" data-mp="11cjqbu626h0m" data-mpi={i} />)}
                </div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-168" data-mp="ow284qyanqmz">
              "{testimonials[currentIndex].text}"
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={next} aria-label="Testimonio siguiente" className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F97316] hover:text-white transition-colors z-10" data-id="element-169" data-mp="yu88h44gcopq">
        <ChevronRight size={24} data-id="element-170" data-mp="66c55gkdnyjz" />
      </button>

      <div className="flex justify-center gap-2 mt-6" data-id="element-171" data-mp="63g6tr4mb7v0">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} aria-label={`Ver testimonio ${idx + 1}`} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-[#F97316]' : 'bg-gray-300'}`} data-id="element-172" data-mp="kvrsemkp9lux" data-mpi={idx} />)}
      </div>
    </div>;
};